<figure class="sb-image-preview" [class.sb-image-preview--failed]="failed">
  @if (clickEnabled) {
  <button
    #thumbnail
    type="button"
    class="sb-image-preview__thumbnail sb-image-preview__thumbnail--clickable"
    [style.width.px]="width()"
    [style.height.px]="height()"
    [attr.aria-label]="'Preview ' + label"
    (mouseenter)="showHover()"
    (mouseleave)="hideHover()"
    (click)="openPreview()">
    <ng-container *ngTemplateOutlet="image"></ng-container>
  </button>
  } @else {
    <span
      #thumbnail
      class="sb-image-preview__thumbnail"
      [class.sb-image-preview__thumbnail--hoverable]="hoverEnabled"
      [style.width.px]="width()"
      [style.height.px]="height()"
      [attr.tabindex]="hoverEnabled ? 0 : null"
      [attr.aria-label]="hoverEnabled ? 'Preview ' + label : null"
      (mouseenter)="showHover()"
      (mouseleave)="hideHover()"
      (focus)="showHover()"
      (blur)="hideHover()">
      <ng-container *ngTemplateOutlet="image"></ng-container>
    </span>
  }
  @if (caption()) {
  <figcaption class="sb-image-preview__caption">{{ caption() }}</figcaption>
  }
</figure>

<ng-template #image>
  @if (!failed) {
  <img
    class="sb-image-preview__image"
    [src]="src()"
    [alt]="alt()"
    [attr.loading]="loading()"
    [style.object-fit]="fit()"
    (error)="onError()">
  }
  @if (failed) {
  <span class="sb-image-preview__placeholder" [attr.aria-label]="alt() || null">
    <i class="fa fa-picture-o" aria-hidden="true"></i>
  </span>
  }
</ng-template>

<ng-template #hoverPreview>
  <img
    class="sb-image-preview__hover-image"
    [src]="fullSrc"
    [alt]="alt()"
    [style.max-width.px]="hoverMaxWidth"
    [style.max-height.px]="hoverMaxHeight"
    (load)="repositionHover()">
</ng-template>

<ng-template #clickPreview>
  <div class="sb-image-preview__modal-body">
    <img class="sb-image-preview__modal-image" [src]="fullSrc" [alt]="alt()">
  </div>
</ng-template>
